import { useEffect, useState } from "react";

export function ProgressTubeBar({
  value,
  label,
  height = 16,
  color = "#89c2d9",
  thresholds = { yellow: 70, red: 90 },
  width = 200,
  minLabel = "0",
  maxLabel = "100",
  grooveBaseColor = "#666",
  grooveEdgeColor = "#1a2c3a",
}) {
  const getFillColor = (percent, base) => {
    if (percent >= thresholds.red) return "#e63946";
    if (percent >= thresholds.yellow) return "#f1c40f";
    return base;
  };

  const fillColor = getFillColor(value, color);
  const safeId = String(label).replace(/[^a-zA-Z0-9-_]/g, "_");

  return (
    <div
      style={{ display: "flex", flexDirection: "column", alignItems: "center" }}
    >
      <svg
        width={width}
        height={height}
        viewBox={`0 0 ${width} ${height}`}
        preserveAspectRatio="none"
      >
        <defs>
          {/* Background groove gradient */}
          <linearGradient
            id={`grad1-${safeId}`}
            x1="100%"
            y1="0%"
            x2="0%"
            y2="0%"
          >
            <stop offset="0%" stopColor={grooveBaseColor} stopOpacity="0.8" />
            <stop offset="100%" stopColor={grooveEdgeColor} stopOpacity="0.3" />
          </linearGradient>

          {/* Fill gradient */}
          <linearGradient
            id={`tubeFillGradient-${safeId}`}
            x1="0"
            y1="0"
            x2="0"
            y2="1"
          >
            <stop offset="0%" stopColor="#ffffff" stopOpacity="0.2" />
            <stop offset="40%" stopColor={fillColor} stopOpacity="1" />
            <stop offset="100%" stopColor="#000000" stopOpacity="0.2" />
          </linearGradient>

          {/* Groove filter */}
          <filter
            id={`filterGroove-${safeId}`}
            x="-10%"
            y="-10%"
            width="130%"
            height="130%"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feOffset dx="3" dy="3" />
            <feGaussianBlur stdDeviation="2.5" />
            <feComposite in2="SourceAlpha" operator="in" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.23 0 0 0 0 0.27 0 0 0 0 0.32 0 0 0 1 0"
            />
          </filter>
        </defs>

        {/* Groove background bar */}
        <rect
          x="0"
          y="0"
          rx={height / 2}
          ry={height / 2}
          width={width}
          height={height}
          fill={`url(#grad1-${safeId})`}
          filter={`url(#filterGroove-${safeId})`}
        />

        {/* Foreground animated fill */}
        <rect
          x="0"
          y="0"
          rx={height / 2}
          ry={height / 2}
          width={(value / 100) * width}
          height={height}
          fill={`url(#tubeFillGradient-${safeId})`}
          style={{ transition: "width 1.5s ease-out" }}
        />
      </svg>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          width: width,
          marginTop: "0.2rem",
          fontSize: "0.9rem",
          color: "#ccc",
          padding: "0 2px",
        }}
      >
        <span>{minLabel}</span>
        <span>{label}</span>
        <span>{maxLabel}</span>
      </div>
    </div>
  );
}
